import { render } from "./money_to_users_from_cashier.vue?vue&type=template&id=60b4ba95"
import script from "./money_to_users_from_cashier.vue?vue&type=script&lang=js"
export * from "./money_to_users_from_cashier.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__